import { render, staticRenderFns } from "./LogisticSubscribeMessageList.vue?vue&type=template&id=5fb772f9&scoped=true"
import script from "./LogisticSubscribeMessageList.vue?vue&type=script&lang=js"
export * from "./LogisticSubscribeMessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb772f9",
  null
  
)

export default component.exports